module.exports = __webpack_public_path__ + "img/pcmonitor.c73f2219.svg";